import { useEffect, ReactNode } from 'react';
import { useAuthContext } from './AuthProvider';
import { useNavigate } from 'react-router-dom';
import { routingPath } from '../../utils/path';

type Props = {
  children: ReactNode;
};

export const AuthGuard = ({ children }: Props) => {
  const { user, loading } = useAuthContext();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !user) {
      navigate(routingPath.login);
    }
  }, [user, loading, navigate]);

  if (loading || !user) return null;
  return <>{children}</>;
};
